import axios from "axios";
import Auth from "../../../Auth/Auth";
import { WEB_SERVER_ADDR } from "../../../constValues";

export async function getApprovalSearchDocs(searchArgs) {
  let restUri = `${WEB_SERVER_ADDR}/api/approval/searchapprovaldocs`;
  const {
    startDate,
    endDate,
    categoryId,
    departmentId,
    employeeId,
    searchType,
    searchWord,
    resultValue,
    limit,
    offset
  } = searchArgs;

  try {
    const response = await axios.post(
      restUri,
      {
        employeeId,
        departmentId,
        categoryId,
        searchStartDate: startDate,
        searchEndDate: endDate,
        searchType,
        searchWord,
        resultValue,
        limit,
        offset
      },
      {
        headers: {
          token: Auth.getUserToken()
        }
      }
    );
    if (!response.data) {
      return [];
    }
    return response.data;
  } catch (err) {
    console.warn(err);
  }
  return [];
}

export async function updateApprovalDoc(
  approverId,
  approvalRequestIndex,
  approvalResult,
  comment
) {
  let restUri = `${WEB_SERVER_ADDR}/api/approval/setapprovalresult`;
  try {
    await axios.post(
      restUri,
      {
        approvalRequestIndex,
        approvalResult: approvalResult ? 2 : 3, // 2 - 승인, 3 - 반려
        comment,
        approverId
      },
      {
        headers: {
          token: Auth.getUserToken()
        }
      }
    );
  } catch (err) {
    console.warn(err);
  }
}
